<template>
	<div class="grid checkinlist">
		<!-- {{checkins}} -->

		<div class="grid list" v-if="checkins.length > 0 && showlist.checkins">
			<div class="grid checkins" v-for="checkin in checkinlist" :key="checkin.name" @click="openSeat(checkin)">
				<div class="grid info">
					<span class="grid name">{{checkin.checkin.name}}</span>
					<span class="grid bill" :class="{pa: !checkBill(checkin.checkin.ombrelloni), unpaid: checkBill(checkin.checkin.ombrelloni)}" v-if="$store.state.hotels.activehotel.cashier">
						<!-- <span class="unpaid">{{checkBill(checkin.checkin.ombrelloni)}}</span> -->
						<unicon name="exclamation-triangle" height="16" width="16" fill="#FF0132" v-if="checkBill(checkin.checkin.ombrelloni)" />
						<unicon name="check-circle" height="16" width="16" fill="#12C300" v-if="!checkBill(checkin.checkin.ombrelloni)" />
					</span>
				</div>
				<div class="grid seat checkin" v-for="ombrellone in checkin.ombrelloni" :key="ombrellone.ombrelloneid">
					<span class="grid id">{{ombrellone.ombrid}}</span>
					<span class="grid room" v-if="$store.state.hotels.activehotel.settings.room">{{ombrellone.room}}</span>
					<span class="grid stay" >{{ombrellone.arrival}} - {{ombrellone.departure}}</span>
					<!-- <span class="grid items">{{ombrellone.items}}</span> -->
				</div>
			</div>
		</div>

		<div class="grid list" v-if="checkouts.length > 0 && showlist.checkouts">
			<!-- {{checkoutlist}} -->
			<div class="grid checkins" v-for="checkout in checkoutlist" :key="checkout.name" @click="openSeat(checkout)">
				<div class="grid info">
					<span class="grid name">{{checkout.checkout.name}}</span>
					<span class="grid bill" :class="{pa: !checkBill(checkout.checkout.ombrelloni), unpaid: checkBill(checkout.checkout.ombrelloni)}" v-if="$store.state.hotels.activehotel.cashier">
						<!-- <span class="unpaid">{{checkBill(checkout.checkout.ombrelloni)}}</span> -->
						<unicon name="exclamation-triangle" height="16" width="16" fill="#FF0132" v-if="checkBill(checkout.checkout.ombrelloni)" />
						<unicon name="check-circle" height="16" width="16" fill="#12C300" v-if="!checkBill(checkout.checkout.ombrelloni)" />
					</span>
				</div>
				<div class="grid seat checkout" v-for="ombrellone in checkout.ombrelloni" :key="ombrellone.ombrelloneid">
					<span class="grid id">{{ombrellone.ombrid}}</span>
					<span class="grid room" v-if="$store.state.hotels.activehotel.settings.room">{{ombrellone.room}}</span>
					<span class="grid stay" >{{ombrellone.arrival}} - {{ombrellone.departure}}</span>
				</div>
			</div>
		</div>

<!-- 		<div class="grid list2" v-if="checkins.length > 0">
			<div class="grid checkins" v-for="checkin in checkins" :key="checkin.name">
				<span class="grid name">{{checkin.name}}</span>
				<div class="grid queue">
					<div class="grid seat checkin" v-for="ombrellone in checkin.ombrelloni" :key="ombrellone.ombrelloneid">
						<span class="grid id" :class="{free: checkday(ombrellone.arrival)}">{{ombrellone.ombrid}}</span>	
					</div>
				</div>
			</div>
		</div> -->

		<div class="grid list" v-if="checkins.length === 0 && showlist.checkins">
			non ci sono checkin oggi
		</div>

		<div class="grid list" v-if="checkouts.length === 0 && showlist.checkouts">
			non ci sono checkout oggi
		</div>

	</div>
</template>

<script>
import _ from 'lodash'
import moment from 'moment'
// import helper from '../../Mixins/helper'
export default {
  name: 'Checkinlist',
  mixins: [],
  props: {
    checkins: Array,
    checkouts: Array,
    showlist: Object,
    today: [Object, Date]
  },
  data () {
	return {

	}
  },
  methods: {
	checkBill (ombrelloni) {
		// console.log(ombrelloni)
		var unpaid = _.filter(ombrelloni, function (o) {
			// console.log(o.paid)
			return o.paid === false || o.paid == undefined
		})
		// console.log('u: ', unpaid)
		if (unpaid.length > 0) { return true } else { return false }
	},
	openSeat (checkin) {
		console.log('checkin: ', checkin)
		this.$store.commit('ombrelloni/SET_OPENSEAT', checkin)
		// this.$emit('openSeatNavbar'	)
	},
	checkday (arrival) {
		return moment(arrival, 'DD.MM.YYYY').isSame(this.today, 'day')
	}
  },
  filters: {

  },
  watch: {

  },
  computed: {
	checkinlist () {
		var self = this
		var jou = _.map(this.checkins, function (checkin) {
			// console.log(_.filter(checkin.ombrelloni, {arrival: moment(self.today).format('DD.MM.YYYY')}))
			return {
				checkin: checkin,
				ombrelloni: _.filter(checkin.ombrelloni, {arrival: moment(self.today).format('DD.MM.YYYY')})
			}
		})
		console.log(jou)
		return jou
	},
	checkoutlist () {
		var self = this
		var jou = _.map(this.checkouts, function (checkout) {
			console.log(_.filter(checkout.ombrelloni, {departure: moment(self.today).format('DD.MM.YYYY')}))
			return {
				checkout: checkout,
				ombrelloni: _.filter(checkout.ombrelloni, {departure: moment(self.today).format('DD.MM.YYYY')})
			}
		})
		console.log(jou)
		return jou
	}
  },
  beforeMount () {

  },
  beforeDestroy () {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
